<template>
    <b-form-group label="Tipo" label-for="tipoDeUnidade" label-class="font_size_label">
        <validation-provider #default="{ errors }" name="Tipo de Unidade Operacional">
            <v-select id="tipoDeUnidade" :options="options" v-model="selected" placeholder="Selecione o tipo da unidade"
                :clearable="true">
                <span slot="no-options">Nenhuma opção selecionável.</span>
            </v-select>
            <small v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
            </small>
        </validation-provider>
    </b-form-group>
</template>

<script>
import {
    BForm,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BSpinner,
    BFormDatepicker,
    BFormTextarea,
    BOverlay,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";

export default {
    components: {
        BForm,
        BCol,
        BRow,
        BFormGroup,
        BFormInput,
        BButton,
        BTable,
        BSpinner,
        BFormDatepicker,
        BFormTextarea,
        BOverlay,
        ValidationProvider,
        ValidationObserver,
        vSelect,
    },
    props: {
        value: {
            required: true,
        },
        optionsConsulted: {
            required: false,
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            options: [],
            selected: this.value,
        };
    },
    beforeMount() {
        this.setOptions();
    },
    methods: {
        setOptions() {
            if (this.optionsConsulted.length > 0) {
                this.options = this.optionsConsulted;
                return;
            }

            this.options = ['Própria', 'Terceira'];

        },
    },
    watch: {
        selected: function (valor) {
            this.$emit("selected", valor);
        },
        options: function (valor) {
            this.$emit("options", valor);
        },
    },
};
</script>
